import script from "./Navbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=7ee74548&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee74548"]])

export default __exports__